<dx-data-grid #crmReportDataGrid class="fixGridHeight" id="crmReportDataGrid" [dataSource]="crmReportData"  
     [showRowLines]="true" [showColumnLines]="true" [showBorders]="true" [columnAutoWidth]="true" 
    [allowColumnResizing]="true" [rowAlternationEnabled]="true" (onContentReady)="onContentReady($event)"
    [noDataText]="'No data available for the given criteria'">
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-export [enabled]="true"></dxo-export>
    <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
    <dxo-toolbar>
        <dxi-item name="groupPanel"></dxi-item>
        <dxi-item location="after">
            <dx-button text="Reset" stylingMode="contained" type="default" (onClick)="resetFilters()">
            </dx-button>                
        </dxi-item>
        <dxi-item name="searchPanel"></dxi-item>
    </dxo-toolbar>
    <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
        [showInfo]="true" [showNavigationButtons]="false"></dxo-pager>
    
    <dxi-column dataField="dummy" [visible]="false"></dxi-column>
    <dxo-load-panel shadingColor="rgba(0,0,0,0.4)" [showPane]="true" [shading]="false">
    </dxo-load-panel>
    <!-- Below header template is defined for CurrentCustomer - LBSAP report. This will convert N2_KG --to-- NR <br/> KG in report header.
        Couldn't generate a header-cell-tepmplate in code. DevExpress documentation not clear on this topic. So adding it here in HTML for now.-->
    <div *dxTemplate="let info of 'lbsap_product_headerTemplate'">
        <div>{{info.column.caption.split('_')[0]}} <br/> {{"".concat('(',info.column.caption.split('_')[1],')')}}</div>
    </div>         
</dx-data-grid>



